import {
  type UseTransfersTableControllerProps,
  useTransfersTableController,
} from "./TransfersTable.controller";
import { TransfersTablePresentation } from "./TransfersTable.pres";

export const TransfersTable = (props: UseTransfersTableControllerProps) => {
  const controller = useTransfersTableController(props);

  return <TransfersTablePresentation {...controller} />;
};
